/* ------------------------------------------------------------------
 *  Cookieに関する関数
--------------------------------------------------------------------- */

// cookieをset
function setCookies(cookie_name, article_id, add_or_remove) {
  var add_or_remove = add_or_remove || "add";
  let ids_array = [];
  if (Cookies.getJSON(cookie_name)) {
    ids_array = Cookies.getJSON(cookie_name);
  }
  const id_index = $.inArray(article_id, ids_array);
  if (id_index >= 0) {
    ids_array.splice(id_index, 1);
  }
  if (add_or_remove == "add") {
    ids_array.push(article_id);
  }
  Cookies.set(cookie_name, ids_array, { expires: 200 });
}

// 配列ではなく、stringでcookiesをセットしたい場合はこっち
function setStringCookie(cookie_name, string) {
  Cookies.set(cookie_name, string, { expires: 3 });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する
window.setCookies = setCookies;
window.setStringCookie = setStringCookie;

export { setCookies, setStringCookie };
